// Alternate player / dealer, reserving the same four slots throughout the deal.
// An interrupted navigation/account switch cancels the remaining presentation.
export const animateOpeningDeal = async (showStep, isCurrent, onCard = () => {}, pace = 1) => {
  for (let step = 1; step <= 4; step += 1) {
    await new Promise((resolve) => setTimeout(resolve, (step === 1 ? 80 : 320) * pace));
    if (!isCurrent()) return false;
    showStep(step);
    onCard();
  }
  await new Promise((resolve) => setTimeout(resolve, 320 * pace));
  if (!isCurrent()) return false;
  showStep(null);
  return true;
};